/* ================================================================
   BJ Footer — mobile accordion
   Toggles menu-column visibility on small screens.
   On desktop the toggle button acts as a static heading.
   ================================================================ */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 750; // matches CSS

  function isMobile() {
    return window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px)').matches;
  }

  function closeColumn(col) {
    if (!col) return;
    col.setAttribute('data-open', 'false');
    var t = col.querySelector('.bj-footer__col-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function openColumn(col) {
    if (!col) return;
    col.setAttribute('data-open', 'true');
    var t = col.querySelector('.bj-footer__col-toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function init() {
    var columns = document.querySelectorAll('.bj-footer__col');
    if (!columns.length) return;

    columns.forEach(function (col) {
      var toggle = col.querySelector('.bj-footer__col-toggle');
      if (!toggle) return;

      // Touch + click handler — only acts on mobile
      var handler = function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        e.stopPropagation();

        var isOpen = col.getAttribute('data-open') === 'true';

        if (isOpen) {
          closeColumn(col);
        } else {
          // Close all other open columns first (accordion behavior)
          columns.forEach(function (other) {
            if (other !== col) closeColumn(other);
          });
          openColumn(col);
        }
      };

      toggle.addEventListener('click', handler);

      // Keyboard parity
      toggle.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && isMobile()) {
          e.preventDefault();
          handler(e);
        }
      });
    });

    // Reset accordion state when crossing the breakpoint
    var mq = window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px)');
    var onChange = function () {
      columns.forEach(function (col) {
        col.removeAttribute('data-open');
        var t = col.querySelector('.bj-footer__col-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();